import { render, staticRenderFns } from "./TerminePage.vue?vue&type=template&id=291e27da&scoped=true&"
import script from "./TerminePage.vue?vue&type=script&lang=ts&"
export * from "./TerminePage.vue?vue&type=script&lang=ts&"
import style0 from "./TerminePage.vue?vue&type=style&index=0&id=291e27da&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "291e27da",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
installComponents(component, {VBtn})
